import ElementContentSignup from '@/components/sections/builder/elements/body/signup/content';
import ElementSettingSignup from '@/components/sections/builder/elements/body/signup/setting';
import { SignupElementDataType } from '@/components/sections/builder/elements/body/signup/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: SignupElementDataType = {
  name: 'Signup',
  topPadding: 0,
  bottomPadding: 0,
  layout: 'default',
  headingLabel: 'Create account',
  roundedForm: 8,
  buttonLabel: 'Sign up',
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const Signup = {
  type: 'signup',
  group: 'body_signup',
  defaultData,
  PreviewIcon: ElementPreviewIcon,
  Element: ElementContentSignup,
  Setting: ElementSettingSignup,
  isImmutable: true,
  maxEntries: 1,
};

export default Signup;
